<template>
  <div ref="componentTop">
    <template v-if="getDomainType('travelone', 'skione')">
      <div class="layout-segment">
        <h3 class="font-22 mb-24">{{ sectionTitle }}</h3>
        <T1TopRegionyThumbnails
          v-if="regionsWithThumbs"
          :regionsWithThumbsData="regionsWithThumbs"
        />
        <T1TopRegionyTabs
          v-if="regionsWithNoThumbs"
          :regionsWithNoThumbsData="regionsWithNoThumbs"
          :withThumbs="true"
        />
      </div>
    </template>
    <template v-else>
      <div v-if="regiony.length" class="layout-segment">
        <h3 class="font-22 mb-24">{{ sectionTitle }}</h3>
        <T1TopRegionyTabs
          v-if="regiony"
          :regionsWithNoThumbsData="regiony"
          :withThumbs="false"
        />
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";
import T1TopRegionyThumbnails from "./T1TopRegionyThumbnails";
import T1TopRegionyTabs from "./T1TopRegionyTabs";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

export default {
  mixins: [domainTypeMixin],
  components: {
    T1TopRegionyThumbnails,
    T1TopRegionyTabs,
  },
  name: "top-regiony-home",
  data: () => ({
    sectionTitle: "Top regiony",
    url: "/vueregions.json",
    regionsImagesPath: "/travelonecdn/images/regions/",
    regiony: [],
    regionsThumbsNumber: 6,
    regionsWithThumbs: [],
    regionsWithNoThumbs: [],
  }),
  methods: {
    getRegiony() {
      return axios
        .get(CONFIG.API_URL + this.url, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    getRegionsSeparatedArrs() {
      let regionsWithThumbsArr = [];
      let regionsWithNoThumbsArr = [];

      for (let i = 0; i < this.regiony.length; i++) {
        if (i < this.regionsThumbsNumber) {
          regionsWithThumbsArr.push(this.regiony[i]);
        }
      }
      this.regionsWithThumbs = regionsWithThumbsArr;

      for (let i = 0; i < this.regiony.length; i++) {
        if (i >= this.regionsThumbsNumber) {
          regionsWithNoThumbsArr.push(this.regiony[i]);
        }
      }
      this.regionsWithNoThumbs = regionsWithNoThumbsArr;
    },
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj);
          return z;
        }
      } else {
        return [];
      }
    },
    scrollOnRollUp() {
      const componentTop = this.$refs.componentTop;
      componentTop.scrollIntoView();
    },
  },
  mounted() {
    this.getRegiony()
      .then((data) => {
        this.regiony = this.tomatrix(data.regiony.item);
        this.getRegionsSeparatedArrs();
      })
      .catch(() => {
        this.regiony = [];
      });
  },
  created() {
    let that = this;
    this.$on("scrollToRegionsTop", () => {
      that.scrollOnRollUp();
    });
  },
};
</script>
